import React, { Component } from 'react'
import styles from './logo.module.css'
import { Link } from 'gatsby'
import { HOME_ROUTE } from '../../navigation/routes'

class Logo extends Component {
  constructor(props) {
    super(props)

    this.state = {
      colors: {
        primary: '#8d1558',
        secondary: '#00973a',
        tertiary: '#fff',
      },
    }
  }

  render() {
    return (
      <div className={styles.container}>
        <Link to={HOME_ROUTE} className={styles.link}>
          <figure className={styles.figure}>
            <svg
              className={styles.logo}
              xmlns="http://www.w3.org/2000/svg"
              version="1"
              viewBox="0 0 640 382.8"
            >
              <g fill="#1d1d1b">
                <path d="M84.2 382.8H43.4v-5c1.6-.1 3.1-.2 4.7-.4 1.5-.2 2.9-.4 4.1-.8 1.6-.5 2.7-1.4 3.3-2.7.6-1.3.9-2.8.9-4.5v-27.9l-.5-.2c-.8.9-2 2-3.5 3.2s-3.1 2.2-4.7 2.9c-2 1.1-4 1.9-5.9 2.5-1.9.6-4.2.9-7.1.9-4.6 0-8.9-1-12.9-2.9s-7.6-4.6-10.6-8.1-5.4-7.7-7.1-12.8c-1.8-5.1-2.6-10.6-2.6-16.7 0-5.8 1-11 3.1-15.7s4.7-8.8 8.1-12.3c3.2-3.3 7.1-5.9 11.6-7.9s9-2.9 13.4-2.9c3.3 0 6.2.3 8.8 1 2.6.6 4.8 1.4 6.6 2.3 1.6.7 3.2 1.5 4.7 2.6 1.6 1 2.7 1.7 3.4 2.1l6.5-9.9 4.3.4c-.2 3.8-.5 8.4-.8 13.9-.3 5.5-.5 10.3-.5 14.5v69.7c0 1.8.3 3.3 1 4.6.7 1.3 1.7 2.3 3.2 2.9 1.2.5 2.8 1 4.7 1.3 1.9.4 3.4.6 4.6.7v5.2zm-27.8-47.9v-45c-.4-1.3-1.1-2.7-2.1-4.2-1-1.6-2.1-2.9-3.4-4.1-1.4-1.2-3.2-2.2-5.2-3.1-2.1-.8-4.4-1.2-7.1-1.2-5.9 0-10.9 3.1-15 9.2s-6.1 14.6-6.1 25.4c0 4.3.4 8.2 1.2 11.6.8 3.5 2.1 6.7 4.1 9.7 1.8 2.9 4.1 5.1 6.9 6.8 2.8 1.7 6.3 2.6 10.6 2.6 3.7 0 6.8-.8 9.4-2.3 2.5-1.5 4.8-3.3 6.7-5.4zM173.7 347.5l-24.6 1.7-1.1-1.1v-9.6h-.5c-1.2 1.3-2.6 2.6-4.1 4.1-1.5 1.5-3.3 2.8-5.3 3.9-2.3 1.4-4.5 2.4-6.6 3.1-2.1.7-5.2 1.1-9.1 1.1-6.7 0-11.7-2.2-15.2-6.5s-5.2-10.7-5.2-19v-36c0-1.8-.4-3.4-1-4.6-.7-1.2-1.7-2.3-3-3.2-.9-.6-2.1-1.1-3.5-1.3-1.4-.3-2.8-.5-4.4-.6v-5l25.1-1.8 1.1 1.1V326c0 5.5 1.2 9.6 3.7 12.3 2.4 2.8 5.4 4.1 8.8 4.1 2.8 0 5.3-.4 7.5-1.3s4-1.9 5.5-3.1c1.4-1.1 2.6-2.2 3.6-3.4 1-1.2 1.8-2.3 2.4-3.3v-42.7c0-1.7-.4-3.2-1.1-4.5-.7-1.3-1.7-2.4-3-3.3-.9-.6-2.3-1-4.1-1.1-1.8-.1-3.8-.2-6.1-.3v-5l27.4-1.8 1.2 1.1v59.8c0 1.7.4 3.2 1.1 4.4.7 1.2 1.7 2.3 3 3.1.9.6 2 .9 3.3 1.1 1.3.2 2.7.3 4.2.3v5.1zM258.3 347.5c-2.4.9-4.5 1.6-6.3 2.1-1.8.5-3.9.8-6.2.8-4 0-7.1-.9-9.5-2.8-2.4-1.9-3.9-4.6-4.5-8.1h-.5c-3.3 3.7-6.9 6.5-10.7 8.4-3.8 1.9-8.4 2.9-13.7 2.9-5.7 0-10.3-1.7-13.9-5.2-3.6-3.5-5.5-8-5.5-13.6 0-2.9.4-5.5 1.2-7.8s2-4.4 3.7-6.2c1.3-1.5 3-2.9 5-4.1 2.1-1.2 4-2.2 5.9-2.9 2.3-.9 6.9-2.5 13.9-4.8s11.7-4.2 14.2-5.5v-7.6c0-.7-.1-1.9-.4-3.8s-.9-3.7-1.8-5.3c-1-1.9-2.5-3.5-4.3-4.9-1.9-1.4-4.5-2.1-7.9-2.1-2.3 0-4.5.4-6.5 1.2s-3.4 1.6-4.2 2.5c0 1 .2 2.5.7 4.5s.7 3.8.7 5.5c0 1.8-.8 3.4-2.4 4.9-1.6 1.5-3.8 2.2-6.7 2.2-2.5 0-4.4-.9-5.6-2.7-1.2-1.8-1.8-3.8-1.8-6.1s.8-4.6 2.5-6.7c1.7-2.1 3.8-4 6.5-5.7 2.3-1.4 5.1-2.6 8.3-3.6 3.3-1 6.4-1.5 9.6-1.5 4.3 0 8 .3 11.2.9s6.1 1.8 8.7 3.8c2.6 1.9 4.6 4.4 5.9 7.7s2 7.4 2 12.5c0 7.3-.1 13.7-.2 19.4-.2 5.6-.2 11.8-.2 18.5 0 2 .3 3.6 1 4.7.7 1.2 1.7 2.2 3.2 3 .8.5 2 .7 3.6.8s3.3.1 5.1.1v4.6zm-26.7-40.4c-4.3 1.3-8.1 2.5-11.4 3.8-3.3 1.2-6.3 2.8-9.1 4.6-2.5 1.7-4.6 3.8-6 6.2-1.5 2.4-2.2 5.2-2.2 8.5 0 4.2 1.1 7.4 3.3 9.3 2.2 2 5 3 8.4 3 3.6 0 6.8-.9 9.6-2.6 2.8-1.8 5.1-3.8 7-6.2l.4-26.6zM352.9 348.9h-36.8v-5c1.2-.1 2.5-.2 3.9-.3 1.4-.1 2.6-.3 3.5-.6 1.4-.5 2.5-1.3 3.2-2.4s1-2.6 1-4.5v-38.7c0-5.3-1.3-9.5-3.8-12.4-2.5-2.9-5.6-4.4-9.2-4.4-2.7 0-5.2.4-7.4 1.3-2.2.8-4.2 1.9-6 3.1-1.7 1.2-3 2.4-4 3.8s-1.7 2.4-2.2 3.2v43.3c0 1.7.4 3.2 1.1 4.3.7 1.1 1.8 2 3.2 2.6 1.1.5 2.2.9 3.5 1.1 1.2.3 2.5.4 3.9.5v5h-36.9v-5l3.6-.3c1.2-.1 2.3-.3 3.2-.6 1.4-.5 2.5-1.3 3.2-2.4.7-1.1 1-2.6 1-4.5v-46.5c0-1.7-.4-3.3-1.1-4.8-.7-1.4-1.8-2.6-3.1-3.6-1-.6-2.1-1.1-3.4-1.3s-2.8-.5-4.3-.6v-5l25.1-1.7 1.1 1.1v10.6h.4c1.2-1.2 2.8-2.7 4.6-4.4s3.6-3.1 5.2-4.2c1.9-1.2 4.1-2.2 6.7-3.1s5.5-1.2 8.8-1.2c7.2 0 12.6 2.3 16.1 6.8 3.5 4.5 5.2 10.5 5.2 18v39.2c0 1.8.3 3.2.9 4.3.6 1.1 1.7 1.9 3.1 2.6 1.2.5 2.3.9 3.2 1.1.9.2 2.1.4 3.7.5v5.1zM412.6 345.6c-3.3 1.4-6.4 2.5-9.4 3.5-3 .9-6.6 1.4-10.9 1.4-6.3 0-10.8-1.6-13.3-4.8-2.6-3.2-3.9-7.7-3.9-13.5v-51h-13.6v-7.3h13.9v-23.5h13.9v23.5H411v7.3h-21.5v42.1c0 3.2.1 5.8.3 7.9s.8 4 1.6 5.5 2 2.6 3.7 3.4c1.6.8 3.8 1.1 6.6 1.1 1.3 0 3.1-.1 5.6-.3 2.5-.2 4.2-.5 5.2-.9v5.6zM498.4 278.2c-2.3.4-4.5 1.2-6.5 2.5s-3.8 3.5-5.3 6.6c-3 6.8-6.1 13.9-9.3 21.4-3.2 7.4-6.5 15.2-10 23.3-1 2.3-2.1 5.1-3.2 8.3-1.1 3.2-2.2 6.3-3.2 9.2h-6c-4.8-12-9.3-22.9-13.4-32.7s-8.3-20-12.7-30.3c-1-2.3-2.7-4.2-4.9-5.5-2.3-1.3-4.5-2.1-6.8-2.5v-5H452v5.3c-1.5.1-3.4.4-5.7 1-2.3.6-3.4 1.4-3.4 2.4 0 .2.1.5.4 1.2.3.6.5 1.4.8 2.2 2.1 5.2 5 12.4 8.8 21.8 3.8 9.3 6.9 16.8 9.3 22.5 1.8-4.4 4.1-9.8 6.9-16.3 2.8-6.5 5.8-13.8 9-21.8.5-1.4 1-2.7 1.5-3.9.5-1.2.7-2.4.7-3.6 0-.9-.4-1.6-1.3-2.3-.8-.7-1.8-1.3-3-1.8s-2.3-.9-3.4-1.1c-1.1-.3-2-.4-2.8-.5v-4.9h28.8v4.5zM640 348.9h-36.7v-5l3.6-.3c1.2-.1 2.3-.3 3.2-.6 1.4-.5 2.5-1.3 3.2-2.4s1-2.6 1-4.5v-38.9c0-5.3-1.2-9.4-3.6-12.3s-5.4-4.3-9.1-4.3c-2.5 0-4.8.4-7 1.1s-4.2 1.8-6 3.2c-1.5 1.1-2.7 2.3-3.7 3.6-1 1.3-1.7 2.4-2.3 3.2v43.5c0 1.8.3 3.2.9 4.4.6 1.1 1.7 2 3.1 2.6 1.2.5 2.2.8 3.2 1 .9.2 2.2.4 3.7.5v5h-35.9v-5c1.2-.1 2.3-.2 3.4-.3 1.1-.1 2.1-.3 3-.6 1.4-.5 2.5-1.3 3.2-2.4s1-2.6 1-4.5V297c0-5.3-1.2-9.4-3.6-12.3-2.4-2.9-5.5-4.3-9.1-4.3-2.5 0-4.9.4-7.1 1.2-2.2.8-4.2 1.9-6 3.2-1.5 1.1-2.7 2.4-3.8 3.8-1 1.4-1.8 2.5-2.3 3.2V335c0 1.7.4 3.2 1.1 4.4s1.8 2.1 3.2 2.7c1.1.5 2.2.9 3.3 1.1 1.1.3 2.4.4 3.7.5v5H511v-5l3.6-.3c1.2-.1 2.3-.3 3.2-.6 1.4-.5 2.5-1.3 3.2-2.4.7-1.1 1-2.6 1-4.5v-46.8c0-1.6-.4-3.1-1.1-4.4-.7-1.3-1.8-2.4-3.1-3.3-1-.6-2.2-1.1-3.6-1.5-1.4-.4-2.9-.6-4.4-.7v-5l25.2-1.7 1.1 1.1v10.8h.5c1.3-1.3 2.8-2.8 4.7-4.5 1.8-1.7 3.5-3.1 5.1-4.2 1.8-1.2 4-2.2 6.7-3.1 2.7-.8 5.6-1.2 8.7-1.2 4.9 0 9.1 1.3 12.6 3.9 3.5 2.6 6 5.8 7.6 9.5 1.8-1.8 3.5-3.3 4.9-4.7 1.4-1.4 3.2-2.8 5.5-4.3 1.9-1.3 4.2-2.4 6.8-3.2 2.6-.8 5.5-1.2 8.7-1.2 6.4 0 11.4 2.1 15.1 6.3 3.7 4.2 5.6 10.6 5.6 19.3v38.3c0 1.8.3 3.2.9 4.4.6 1.1 1.7 2 3.1 2.6 1.2.5 2.3.8 3.5 1 1.1.2 2.4.4 3.9.5v5.1z" />
              </g>
              <path
                fill={this.state.colors.secondary}
                stroke={this.state.colors.secondary}
                strokeMiterlimit="10"
                strokeWidth="4"
                d="M267.4 61.4h59"
              />
              <path
                fill="none"
                stroke={this.state.colors.secondary}
                strokeMiterlimit="10"
                strokeWidth="3"
                d="M327.6 61.4h62.8"
              />
              <path
                fill="none"
                stroke={this.state.colors.secondary}
                strokeMiterlimit="10"
                strokeWidth="4"
                d="M390.4 61.4l-35.5 58.4M319.6 59l-28.7 61.4M285 118.4h74M359 131.4l-35.1-70"
              />
              <path
                fill="#1d1d1b"
                d="M323 27.7l-2.7 2.2c-4.8-3.8-9.1-7.2-12.9-10.1s-6.6-5.1-8.4-6.5c-1.8-1.5-3-2.7-3.7-3.6-.7-.9-1.1-2.4-1.1-4.3 0-1.4.5-2.6 1.6-3.7s2.5-1.7 4.1-1.7c1.8 0 3.4.4 4.7 1.3 1.3.8 2.7 2.5 4.2 4.9 1.6 2.6 3.5 5.5 5.6 8.8 2.2 3.2 5 7.5 8.6 12.7z"
              />
              <path
                fill="none"
                stroke={this.state.colors.secondary}
                strokeMiterlimit="10"
                strokeWidth="4"
                d="M322 173l-33.2-54.6"
              />
              <path
                fill={this.state.colors.tertiary}
                stroke={this.state.colors.secondary}
                strokeMiterlimit="10"
                strokeWidth="4"
                d="M355.2 118.4l-35.6 58.4"
              />
              <path
                fill="none"
                stroke={this.state.colors.secondary}
                strokeMiterlimit="10"
                strokeWidth="4"
                d="M290.9 117.9l-33.2-54.6"
              />
              <circle
                cx="390.4"
                cy="61.4"
                r="20.4"
                fill={this.state.colors.primary}
                stroke={this.state.colors.tertiary}
                strokeMiterlimit="10"
                strokeWidth="4"
              />
              <circle
                cx="290.9"
                cy="118.4"
                r="24"
                fill={this.state.colors.primary}
                stroke={this.state.colors.tertiary}
                strokeMiterlimit="10"
                strokeWidth="4"
              />
              <circle
                cx="354.9"
                cy="118.4"
                r="18.5"
                fill={this.state.colors.primary}
                stroke={this.state.colors.tertiary}
                strokeMiterlimit="10"
                strokeWidth="4"
              />
              <circle
                cx="261.9"
                cy="61.4"
                r="19.2"
                fill={this.state.colors.primary}
                stroke={this.state.colors.tertiary}
                strokeMiterlimit="10"
                strokeWidth="4"
              />
              <circle
                cx="323.9"
                cy="172.5"
                r="18"
                fill={this.state.colors.primary}
                stroke={this.state.colors.tertiary}
                strokeMiterlimit="10"
                strokeWidth="4"
              />
              <circle
                cx="323.9"
                cy="61.4"
                r="21.6"
                fill={this.state.colors.primary}
                stroke={this.state.colors.tertiary}
                strokeMiterlimit="10"
                strokeWidth="4"
              />
            </svg>
          </figure>
          <figcaption className={styles.text}>
            Distribución de Vinos y Servicios integrales de hostelería
          </figcaption>
        </Link>
      </div>
    )
  }
}

export default Logo
